module.exports = __webpack_public_path__ + "assets/img/title-a1e4d8ec.png";